import ActionButtons, {
  ActionButtonWrapper,
} from '@bit/vibedev.web.components.action-buttons';

export { ActionButtonWrapper };

export default ActionButtons;
